/* eslint-disable */
// /admin/login — single admin login form (username + password)
import React, { useState } from 'react';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '@/larinz/auth';

export default function AdminLogin() {
  const { login, error, user, checking } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dest = (location.state && location.state.from) || '/admin/dashboard';

  if (checking) return null;
  if (user) return <Navigate to={dest} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await login(username.trim(), password);
    setBusy(false);
    if (ok) navigate(dest, { replace: true });
  };

  return (
    <div style={{
      minHeight: '100vh', background: '#0A0A0A', color: '#fff',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: 'Inter, sans-serif',
    }} data-testid="admin-login-screen">
      <form onSubmit={submit} style={{
        width: '100%', maxWidth: 380, padding: 36,
        background: '#111', border: '1px solid rgba(255,255,255,.08)', borderRadius: 12,
      }}>
        <div style={{ fontSize: 11, letterSpacing: 4, color: '#A5FF12', fontWeight: 800, marginBottom: 14 }}>
          ADMIN · LARINZ LABZ
        </div>
        <h1 style={{ fontWeight: 900, fontSize: 28, letterSpacing: -1, textTransform: 'uppercase', margin: '0 0 24px' }}>
          Sign in<span style={{ color: '#A5FF12' }}>.</span>
        </h1>

        <label style={{ fontSize: 10, color: '#888', letterSpacing: 2, textTransform: 'uppercase', fontWeight: 700, display: 'block', marginBottom: 6 }}>Username</label>
        <input
          data-testid="admin-username-input"
          type="text" autoFocus autoComplete="username"
          value={username} onChange={e => setUsername(e.target.value)}
          style={inputStyle} />

        <label style={{ fontSize: 10, color: '#888', letterSpacing: 2, textTransform: 'uppercase', fontWeight: 700, display: 'block', margin: '16px 0 6px' }}>Password</label>
        <input
          data-testid="admin-password-input"
          type="password" autoComplete="current-password"
          value={password} onChange={e => setPassword(e.target.value)}
          style={inputStyle} />

        {error && (
          <div data-testid="admin-login-error" style={{
            background: 'rgba(255,80,80,.08)', border: '1px solid rgba(255,80,80,.25)',
            color: '#ff9a9a', padding: '10px 12px', borderRadius: 6,
            fontSize: 13, marginTop: 16,
          }}>{error}</div>
        )}

        <button
          data-testid="admin-login-submit"
          type="submit" disabled={busy}
          style={{
            width: '100%', marginTop: 22, padding: '14px 18px',
            background: '#A5FF12', color: '#111', border: 'none',
            borderRadius: 999, fontWeight: 800, letterSpacing: 1,
            textTransform: 'uppercase', cursor: busy ? 'wait' : 'pointer',
            fontSize: 13, opacity: busy ? .7 : 1,
          }}>{busy ? 'Signing in…' : 'Sign in →'}</button>

        <div style={{ marginTop: 24, textAlign: 'center' }}>
          <a href="/" style={{ fontSize: 11, color: '#888', letterSpacing: 1, textTransform: 'uppercase', fontWeight: 700 }}>← Back to site</a>
        </div>
      </form>
    </div>
  );
}

const inputStyle = {
  width: '100%', padding: '12px 14px',
  background: '#0A0A0A', border: '1.5px solid rgba(255,255,255,.12)',
  borderRadius: 8, color: '#fff', fontSize: 14, fontFamily: 'Inter',
  outline: 'none',
};
